import React from "react";
import "./ConfirmModal.css"; // Optional: use for styling
import PropTypes from 'prop-types';
const ConfirmModal = ({
  title = "Are you sure?",
  message = "",
  confirmText = "Yes",
  cancelText = "No",
  onConfirm,
  onCancel,
}) => {
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>{title}</h3>
        {message && <p>{message}</p>}
        <div style={{ marginTop: "1rem" }}>
          <button onClick={onConfirm} style={{ marginRight: "1rem" }}>
            {confirmText}
          </button>
          <button onClick={onCancel}>{cancelText}</button>
        </div>
      </div>
    </div>
  );
};

ConfirmModal.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};
export default ConfirmModal;
